/**
 * @file   src\Pages\Locations.tsx
 * @brief  Locations page.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import {
  React,
  useState,
  useNavigate,
  Link,
  Modal,
  useEffect,
} from "../utils/thirdpartyComponents";
import { Button } from "react-bootstrap";
import { useParams } from "react-router-dom";
import CWFooter from "src/components/CWFooter";
import { useAppDispatch, useAppSelector } from "src/hooks";
import { RootState } from "src/store";
import { userLogout } from "src/store/actions/authAction";
import { formatPhoneNumber, getFirstLettersFromName, formatMoney } from "../utils/helper";
import "src/styles/inner-page-styles.scss";
import { getFromLocalStorage } from "src/utils/helper";
import { pageURLs } from "src/utils/pageUrls";
import { IMyprofileSettings } from "../interfaces/generalInterface";
import axios from "../config/axiosConfig";
import { GiftCardApi, LocationApi, ProfileApi, SubscriptionandwashpriceApi } from "../utils/apiUrls";
import { MessageToaster } from "src/utils/toastUtil";

const Settings = () => {
  const navigate = useNavigate();
  // Route information variable
  const params = useParams();
  // Declare action dispatch.
  const dispatch = useAppDispatch();
  // Instantiate MessageToaster
  const toaster = new MessageToaster();
  const settings = getFromLocalStorage("CARWASH_COMPANY_SETTINGS_DATA") || {};

  const carwashdata = getFromLocalStorage("CARWASH_DATA");
  console.log(carwashdata)
  // Initialise state for user
  const [user, setUser] = useState<IMyprofileSettings>({
    UserID: 0,
    FullName: "",
    Phone: "",
    Email: "",
    WashName: "",
    Price: "",
    Total: "",
  });
  const [singleLocation, setSingleLocation] = useState<boolean>(false);
  const [hasActiveFamilyCodeDiscount,setHasActiveFamilyCodeDiscount] = useState(false);
  const [isChildUser,setIsChildUser] = useState(false);
  const [isParentUser,setIsParentUser] = useState(false)
  const [userHasActiveSubscription,setuserHasActiveSubscription]= useState(false)
  const [showWalletMenu, setShowWalletMenu] = useState(true);
  
  

  const fetchProfileData = async () => {
    // Instantiate MessageToaster
    const toaster = new MessageToaster();

    try {
      const responseProfile = await axios.get(ProfileApi.PROFILE_FETCH);

      if (responseProfile?.data?.error === 0) {
        const profileData: IMyprofileSettings = responseProfile?.data?.data;
        setUser(profileData);
      } else {
        toaster.toastError(responseProfile?.data?.message);
      }
    } catch (error: any) {
      throw new Error(error?.response?.data?.message || error?.message);
    }
  };

  const fetchLocation = async () => {
    try {
      const locationData = await axios.get(LocationApi.LOCATION_FETCH);
      if (locationData?.data?.data?.length === 1) {
        setSingleLocation(true);
      }
    } catch (error: any) {
      throw new Error(error?.response?.data?.message || error?.message);
    }
  };

  const fetchGiftCardWallet = async () => {
    const locationId = Number(localStorage.getItem("selectedLocation") || 0);
    if (!locationId) {
      return;
    }
    try {
      const { data } = await axios.get(GiftCardApi.WALLET, {
        params: { locationId },
      });
      const status = Number(data?.statusCode ?? data?.error ?? 0);
      if (status === 1041) {
        setShowWalletMenu(false);
      }
    } catch (error: any) {
      const body = error?.data || error?.response?.data;
      const status = Number(body?.statusCode ?? body?.error ?? 0);
      if (status === 1041) {
        setShowWalletMenu(false);
      }
    }
  };

  useEffect(() => {
    fetchProfileData();
    fetchLocation();
    // if(carwashdata.parentId!=0 && carwashdata.parentId!=null)
    fetchFamilyPlan()
    fetchGiftCardWallet();
  }, []);

  // Initialise state for promotion count
  const [promotionCount, setPromotionCount] = useState(2);
  const [showLogoutConfirmation, setShowLogoutConfirmation] =
    useState<boolean>(false);
  const { isLogoutSuccess, errorCode, errorMessage } = useAppSelector(
    (state: RootState) => state.auth
  );

  // Triggers on clicking not implimented items
  function handleComingsoon() {
    toaster.toastSuccess("Coming soon!");
  }

  // Triggers on clicking locations
  function handleLocationClick() {
    navigate("/" + params.carwashname + "/" + pageURLs.location_switch, {
      state: { origin: "Settings" },
    });
  }

  const signout = () => {
    setShowLogoutConfirmation(true);
  };

  const handleOnHide = () => {
    setShowLogoutConfirmation(false);
  };

  const ConfirmLogout = () => {
    const data = getFromLocalStorage("CARWASH_DATA");
    if (data && data.accessToken) {
      setShowLogoutConfirmation(false);
      dispatch(userLogout());
    }
  };

         const fetchFamilyPlan = async () => {
              const { data } = await axios.get(SubscriptionandwashpriceApi.CHECK_PARENT_HAS_SUBSCRIPTION, {
                        params: {
                           locationId: localStorage.getItem('selectedLocation')
                        }
                      });
                      // setLoading(false); // Hide loader
                      if(data.error === 0)
                      {
                        setIsChildUser(data?.data?.hasParent)
                        setIsParentUser(data?.data?.hasChild)
                        
                        if(data.data.hasActiveSubscription==true && data.data.hasPaymentMethods==true)
                        {
                          
                          setHasActiveFamilyCodeDiscount(true)
                          
                        }
                        setuserHasActiveSubscription(data?.data?.userHasActiveSubscription)
                        
                      }
                      else{
                         toaster.toastError(data.message);
                          // navigate("/"+params.carwashname+"/"+pageURLs.home)
                      }
            }

  // Navigate user to login page after sucessfull logout.
  useEffect(() => {
    if (isLogoutSuccess && errorCode === 0) {
      localStorage.removeItem("CARWASH_DATA");
      window.location.href = `${process.env.REACT_APP_SITE_URL || ""}${
        params.carwashname
      }`;
    } else if (!isLogoutSuccess && errorCode > 0 && errorMessage) {
      toaster.toastError(errorMessage);
    }
  }, [isLogoutSuccess]);

  return (
    <div className="common-content-wrap pb-70">
      <div className="inner-content-wrap signup-block">
        <div className="common-header">
          <div className="pe-4 ps-4 pt-0 pb-0 h-100">
            <div className="common-header-inner">Settings</div>
          </div>
        </div>
        <div className="main-content-wrap pe-0 ps-0 pt-0">
          <div className="settings-sec">
            <div className="settings-top-sec text-center">
              <div className="prof-img">
                {getFirstLettersFromName(user.FullName)}
              </div>
              <h2>{user.FullName}</h2>
              <p>{formatPhoneNumber(user.Phone)}</p>
              <p>{user.Email}</p>
              <Button
                variant="primary"
                className="primary-btn btn-sm"
                onClick={() =>
                  navigate("/" + params.carwashname + "/" + pageURLs.myprofile)
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12.596"
                  height="12.596"
                  viewBox="0 0 12.596 12.596"
                >
                  <path
                    d="M0,9.937V12.6H2.659l7.7-7.768L7.7,2.169,0,9.937ZM12.386,2.8a.676.676,0,0,0,0-.98L10.777.21a.676.676,0,0,0-.98,0L8.538,1.47,11.2,4.129l1.19-1.33Z"
                    fill="#172951"
                    fillRule="evenodd"
                  />
                </svg>
                Edit Info
              </Button>
            </div>

            <div className="settings-bottom-sec">
              <Link
                to={"/" + params.carwashname + "/" + pageURLs.my_subscriptions}
                className="settings-menu-item align-items-start"
              >
                <div className="settings-menu-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                  >
                    <g transform="translate(-16.42 -16.42)">
                      <path
                        d="M25.92,23.9a.7.7,0,0,1,.7.7.633.633,0,0,0,1.267,0,1.96,1.96,0,0,0-1.33-1.848v-.359a.633.633,0,1,0-1.267,0v.359a1.957,1.957,0,0,0,.634,3.811.7.7,0,1,1-.7.7.633.633,0,1,0-1.267,0A1.958,1.958,0,0,0,25.286,29.1v.359a.633.633,0,1,0,1.267,0V29.1a1.957,1.957,0,0,0-.633-3.81.7.7,0,0,1,0-1.391Zm0-7.476a9.467,9.467,0,0,0-5.151,1.517A.633.633,0,1,0,21.457,19a8.233,8.233,0,1,1-2.48,2.492.633.633,0,0,0-1.067-.683,9.5,9.5,0,1,0,8.009-4.39Z"
                        fill="#7e7e7e"
                      />
                    </g>
                  </svg>
                </div>
                <div className="settings-menu-text">
                  <h2 className="pb-2">My Subscriptions</h2>
                  <p>
                    <span>{user.WashName ? user.WashName : ""}</span>
                    <span className="settings-price-tag">
                      {user.Price
                        ? formatMoney(parseFloat(user.Price))
                        : ""}
                    </span>
                  </p>
                </div>
                <div className="settings-right-arrow">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14.95"
                    height="12.147"
                    viewBox="0 0 14.95 12.147"
                  >
                    <g
                      id="Group_44"
                      data-name="Group 44"
                      transform="translate(0.75 1.057)"
                    >
                      <line
                        id="Line_55"
                        data-name="Line 55"
                        x2="13.157"
                        transform="translate(0 5.016)"
                        fill="none"
                        stroke="#0182f0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      />
                      <path
                        id="Path_267"
                        data-name="Path 267"
                        d="M13,8l4.269,5.016L13,18.033"
                        transform="translate(-3.819 -8)"
                        fill="none"
                        stroke="#0182f0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      />
                    </g>
                  </svg>
                </div>
              </Link>
              {showWalletMenu ? <Link
                to={"/" + params.carwashname + "/" + pageURLs.my_wallet}
                className="settings-menu-item align-items-center"
              >
                <div className="settings-menu-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18.116" viewBox="0 0 19 18.116">
  <g id="wallet-money-svgrepo-com" transform="translate(-1.25 -2.25)">
    <path id="Path_692" data-name="Path 692" d="M9.448,10.576H5.913a.663.663,0,1,1,0-1.326H9.448a.663.663,0,0,1,0,1.326Z" transform="translate(-0.465 -0.814)" fill="#7e7e7e"/>
    <path id="Path_693" data-name="Path 693" d="M17.768,10.25h2.3c.084,0,.13,0,.181,0a1.587,1.587,0,0,1,1.509,1.439c0,.052,0,.1,0,.178v3.388c0,.078,0,.126,0,.178a1.587,1.587,0,0,1-1.508,1.439c-.052,0-.1,0-.182,0h-2.3a3.424,3.424,0,0,1-3.518-3.314A3.424,3.424,0,0,1,17.768,10.25Zm2.3,5.3h.1a.265.265,0,0,0,.266-.209c0-.017,0-.042,0-.085V11.87c0-.043,0-.067,0-.087a.266.266,0,0,0-.267-.207h-2.4a2.1,2.1,0,0,0-2.192,1.988,2.1,2.1,0,0,0,2.192,1.988Z" transform="translate(-1.512 -0.93)" fill="#7e7e7e"/>
    <path id="Path_694" data-name="Path 694" d="M11.634,20.715H8.983c-3.511,0-5.274,0-6.5-1.23s-1.229-2.992-1.229-6.5,0-5.274,1.229-6.5S5.471,5.25,8.983,5.25h2.651c3.511,0,5.274,0,6.5,1.229.9.9,1.128,2.133,1.2,3.824l-1.324.055c-.067-1.621-.287-2.418-.811-2.942-.841-.841-2.42-.841-5.566-.841H8.983c-3.146,0-4.725,0-5.566.841s-.841,2.42-.841,5.566,0,4.725.841,5.566,2.42.841,5.566.841h2.651c3.146,0,4.725,0,5.566-.841.524-.524.744-1.321.811-2.942l1.324.055c-.07,1.692-.3,2.922-1.2,3.824C16.907,20.715,15.145,20.715,11.634,20.715Z" transform="translate(0 -0.349)" fill="#7e7e7e"/>
    <path id="Path_695" data-name="Path 695" d="M5.913,6.227a.663.663,0,0,1-.367-1.215l3.3-2.189a3.523,3.523,0,0,1,3.851,0L16,5.012a.663.663,0,1,1-.733,1.1l-3.3-2.189a2.212,2.212,0,0,0-2.386,0l-3.3,2.189A.66.66,0,0,1,5.913,6.227Z" transform="translate(-0.465)" fill="#7e7e7e"/>
    <path id="Path_696" data-name="Path 696" d="M17.883,14.767h-.008a.884.884,0,0,1,0-1.767h.008a.884.884,0,1,1,0,1.767Z" transform="translate(-1.83 -1.25)" fill="#7e7e7e"/>
  </g>
</svg>

                </div>
                <div className="settings-menu-text">
                  <h2>My Wallet</h2>
                </div>
                <div className="settings-right-arrow">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14.95"
                    height="12.147"
                    viewBox="0 0 14.95 12.147"
                  >
                    <g
                      id="Group_44"
                      data-name="Group 44"
                      transform="translate(0.75 1.057)"
                    >
                      <line
                        id="Line_55"
                        data-name="Line 55"
                        x2="13.157"
                        transform="translate(0 5.016)"
                        fill="none"
                        stroke="#0182f0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      />
                      <path
                        id="Path_267"
                        data-name="Path 267"
                        d="M13,8l4.269,5.016L13,18.033"
                        transform="translate(-3.819 -8)"
                        fill="none"
                        stroke="#0182f0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      />
                    </g>
                  </svg>
                </div>
              </Link> : null}
              {!singleLocation ? (
                <a
                  onClick={handleLocationClick}
                  className="settings-menu-item align-items-center"
                >
                  <div className="settings-menu-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="19"
                      height="19.001"
                      viewBox="0 0 19 19.001"
                    >
                      <g transform="translate(-140 -72)">
                        <g transform="translate(140 72)">
                          <g transform="translate(2.286 0)">
                            <path
                              d="M13.214,19.286a.74.74,0,0,1-.467-.165c-.175-.142-4.287-3.526-6-7.217a.68.68,0,0,1,.366-.913.735.735,0,0,1,.952.351,22.515,22.515,0,0,0,5.14,6.313c1.97-1.832,5.784-5.927,5.784-8.582a5.772,5.772,0,0,0-11.543,0A.722.722,0,0,1,6,9.074a7.216,7.216,0,0,1,14.429,0c0,4.088-6.453,9.79-6.728,10.032A.74.74,0,0,1,13.214,19.286Z"
                              transform="translate(-6 -2)"
                              fill="#7e7e7e"
                            />
                          </g>
                          <g transform="translate(7.215 4.329)">
                            <path
                              d="M14.286,12.572a2.286,2.286,0,1,1,2.286-2.286A2.288,2.288,0,0,1,14.286,12.572Zm0-3.429a1.143,1.143,0,1,0,1.143,1.143A1.144,1.144,0,0,0,14.286,9.143Z"
                              transform="translate(-12 -8)"
                              fill="#7e7e7e"
                            />
                          </g>
                          <g transform="translate(0 13.857)">
                            <path
                              d="M20.322,26.143H2.679a.71.71,0,0,1-.587-.285.494.494,0,0,1,0-.57l2.714-4a.751.751,0,0,1,.926-.213.526.526,0,0,1,.252.779L3.848,25h15.3l-2.134-3.145a.526.526,0,0,1,.252-.779.75.75,0,0,1,.926.213l2.714,4a.494.494,0,0,1,0,.57A.708.708,0,0,1,20.322,26.143Z"
                              transform="translate(-2 -20.999)"
                              fill="#7e7e7e"
                            />
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>
                  <div className="settings-menu-text">
                    <h2>Locations</h2>
                  </div>
                  <div className="settings-right-arrow">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14.95"
                      height="12.147"
                      viewBox="0 0 14.95 12.147"
                    >
                      <g
                        id="Group_44"
                        data-name="Group 44"
                        transform="translate(0.75 1.057)"
                      >
                        <line
                          id="Line_55"
                          data-name="Line 55"
                          x2="13.157"
                          transform="translate(0 5.016)"
                          fill="none"
                          stroke="#0182f0"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.5"
                        />
                        <path
                          id="Path_267"
                          data-name="Path 267"
                          d="M13,8l4.269,5.016L13,18.033"
                          transform="translate(-3.819 -8)"
                          fill="none"
                          stroke="#0182f0"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.5"
                        />
                      </g>
                    </svg>
                  </div>
                </a>
              ) : (
                ""
              )}

              {/* uncomment and change the link when it is impletented  */}
              <Link
                to={"/" + params.carwashname + "/" + pageURLs.refer_friend}
                className="settings-menu-item align-items-center"
              >
                {/* <Link to={""} onClick={handleComingsoon} className="settings-menu-item align-items-center"> */}
                <div className="settings-menu-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                  >
                    <g transform="translate(-129 -381.5)">
                      <path
                        d="M3.221,16.623a.638.638,0,0,1-.139-.125A9.5,9.5,0,0,1,9.5,0,9.233,9.233,0,0,1,11,.12a.645.645,0,0,1-.206,1.274,8,8,0,0,0-1.289-.1A8.2,8.2,0,0,0,3.445,15.037a7.238,7.238,0,0,1,3.5-2.774,4.335,4.335,0,1,1,5.108,0,7.236,7.236,0,0,1,3.5,2.778,8.2,8.2,0,0,0,2.049-6.829A.645.645,0,1,1,18.88,8,9.226,9.226,0,0,1,19,9.5a9.437,9.437,0,0,1-2.783,6.717q-.161.161-.328.313a.662.662,0,0,1-.074.067,9.492,9.492,0,0,1-12.594.026ZM9.5,17.709a8.143,8.143,0,0,0,5.1-1.773A5.963,5.963,0,0,0,9.57,13.1H9.43a5.963,5.963,0,0,0-5.025,2.835A8.168,8.168,0,0,0,9.5,17.709Zm.067-5.9a3.044,3.044,0,1,0-.133,0h.133Zm5.928-6.732V3.4H13.927a.622.622,0,0,1-.646-.594.621.621,0,0,1,.646-.593h1.568V.646a.6.6,0,1,1,1.189,0V2.214h1.671A.621.621,0,0,1,19,2.807a.622.622,0,0,1-.646.594H16.683V5.073a.6.6,0,1,1-1.189,0Z"
                        transform="translate(129 381.5)"
                        fill="#7e7e7e"
                      />
                    </g>
                  </svg>
                </div>
                <div className="settings-menu-text">
                  <h2>Refer a Friend</h2>
                </div>
                <div className="settings-right-arrow">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14.95"
                    height="12.147"
                    viewBox="0 0 14.95 12.147"
                  >
                    <g
                      id="Group_44"
                      data-name="Group 44"
                      transform="translate(0.75 1.057)"
                    >
                      <line
                        id="Line_55"
                        data-name="Line 55"
                        x2="13.157"
                        transform="translate(0 5.016)"
                        fill="none"
                        stroke="#0182f0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      />
                      <path
                        id="Path_267"
                        data-name="Path 267"
                        d="M13,8l4.269,5.016L13,18.033"
                        transform="translate(-3.819 -8)"
                        fill="none"
                        stroke="#0182f0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      />
                    </g>
                  </svg>
                </div>
              </Link>
            {(!isChildUser )?
                <Link
                to={"/" + params.carwashname + "/" + pageURLs.refer_family}
                state={{ isParentUser: isParentUser,userHasActiveSubscription : userHasActiveSubscription }}
                className="settings-menu-item align-items-center"
              >
                {/* <Link to={""} onClick={handleComingsoon} className="settings-menu-item align-items-center"> */}
                <div className="settings-menu-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                  >
                    <g transform="translate(-129 -381.5)">
                      <path
                        d="M3.221,16.623a.638.638,0,0,1-.139-.125A9.5,9.5,0,0,1,9.5,0,9.233,9.233,0,0,1,11,.12a.645.645,0,0,1-.206,1.274,8,8,0,0,0-1.289-.1A8.2,8.2,0,0,0,3.445,15.037a7.238,7.238,0,0,1,3.5-2.774,4.335,4.335,0,1,1,5.108,0,7.236,7.236,0,0,1,3.5,2.778,8.2,8.2,0,0,0,2.049-6.829A.645.645,0,1,1,18.88,8,9.226,9.226,0,0,1,19,9.5a9.437,9.437,0,0,1-2.783,6.717q-.161.161-.328.313a.662.662,0,0,1-.074.067,9.492,9.492,0,0,1-12.594.026ZM9.5,17.709a8.143,8.143,0,0,0,5.1-1.773A5.963,5.963,0,0,0,9.57,13.1H9.43a5.963,5.963,0,0,0-5.025,2.835A8.168,8.168,0,0,0,9.5,17.709Zm.067-5.9a3.044,3.044,0,1,0-.133,0h.133Zm5.928-6.732V3.4H13.927a.622.622,0,0,1-.646-.594.621.621,0,0,1,.646-.593h1.568V.646a.6.6,0,1,1,1.189,0V2.214h1.671A.621.621,0,0,1,19,2.807a.622.622,0,0,1-.646.594H16.683V5.073a.6.6,0,1,1-1.189,0Z"
                        transform="translate(129 381.5)"
                        fill="#7e7e7e"
                      />
                    </g>
                  </svg>
                </div>
                <div className="settings-menu-text">
                  <h2>Family plan</h2>
                </div>
                <div className="settings-right-arrow">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14.95"
                    height="12.147"
                    viewBox="0 0 14.95 12.147"
                  >
                    <g
                      id="Group_44"
                      data-name="Group 44"
                      transform="translate(0.75 1.057)"
                    >
                      <line
                        id="Line_55"
                        data-name="Line 55"
                        x2="13.157"
                        transform="translate(0 5.016)"
                        fill="none"
                        stroke="#0182f0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      />
                      <path
                        id="Path_267"
                        data-name="Path 267"
                        d="M13,8l4.269,5.016L13,18.033"
                        transform="translate(-3.819 -8)"
                        fill="none"
                        stroke="#0182f0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      />
                    </g>
                  </svg>
                </div>
              </Link> :""}
              
               

              {/* uncomment and change the link when it is impletented  */}
              <Link
                to={"/" + params.carwashname + "/" + pageURLs.promotions}
                className="settings-menu-item align-items-center"
              >
                <div className="settings-menu-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24.337"
                    height="23.406"
                    viewBox="0 0 24.337 23.406"
                  >
                    <path
                      d="M20,11.355a3.07,3.07,0,0,0-2.452-3v-2.2a2.155,2.155,0,0,0-2.955-2L9.506,6.189l.455,1.138,5.091-2.036a.951.951,0,0,1,1,.206.924.924,0,0,1,.271.658v9.481a.93.93,0,0,1-.928.929.915.915,0,0,1-.346-.067l-7-2.8V7.065H4.466a3.041,3.041,0,0,0-2.165.9l-.147.147a3.942,3.942,0,0,0,0,5.574l.731.731,1.1,5.752a1.227,1.227,0,0,0,1.2,1H7.921a1.226,1.226,0,0,0,1.2-1.455l-.562-2.95-1.2.229.562,2.95H5.185l-.992-5.21H7.317l7.273,2.909a2.155,2.155,0,0,0,2.959-2V14.358A3.07,3.07,0,0,0,20,11.355ZM6.823,13.5H3.706l-.685-.685a2.709,2.709,0,0,1,0-3.841l.147-.147a1.824,1.824,0,0,1,1.3-.537H6.823Zm10.726-.412V9.621a1.839,1.839,0,0,1,0,3.467Z"
                      transform="matrix(0.914, -0.407, 0.407, 0.914, -2.54, 4.481)"
                      fill="#7e7e7e"
                    />
                  </svg>
                </div>
                <div className="settings-menu-text">
                  {/*<h2><span className="promotions-badge-wrap">Promotions<span className="promotions-badge"></span></span></h2>*/}

                  <h2>
                    <span className="promotions-badge-wrap">
                      Promotions
                      {/* <span className="position-absolute top-0 start-112 translate-middle badge rounded-pill bg-red">
                      {promotionCount}
                      <span className="visually-hidden">unread promotions</span>
                    </span> */}
                    </span>
                  </h2>
                </div>
                <div className="settings-right-arrow">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14.95"
                    height="12.147"
                    viewBox="0 0 14.95 12.147"
                  >
                    <g
                      id="Group_44"
                      data-name="Group 44"
                      transform="translate(0.75 1.057)"
                    >
                      <line
                        id="Line_55"
                        data-name="Line 55"
                        x2="13.157"
                        transform="translate(0 5.016)"
                        fill="none"
                        stroke="#0182f0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      />
                      <path
                        id="Path_267"
                        data-name="Path 267"
                        d="M13,8l4.269,5.016L13,18.033"
                        transform="translate(-3.819 -8)"
                        fill="none"
                        stroke="#0182f0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      />
                    </g>
                  </svg>
                </div>
              </Link>

              {
                carwashdata.parentId!=0 && carwashdata.parentId!=null && hasActiveFamilyCodeDiscount ? "" : <Link
                to={"/" + params.carwashname + "/" + pageURLs.update_payment}
                className="settings-menu-item align-items-center"
              >
                <div className="settings-menu-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19"
                    height="17.138"
                    viewBox="0 0 19 17.138"
                  >
                    <g id="Balance_Limit" transform="translate(-1.1 -2.56)">
                      <path
                        id="Path_655"
                        data-name="Path 655"
                        d="M4.232,16.505A2.23,2.23,0,0,1,2,14.273V5.692A2.23,2.23,0,0,1,4.232,3.46H17.621a2.232,2.232,0,0,1,2.232,2.232v8.582a2.232,2.232,0,0,1-2.232,2.232Z"
                        transform="translate(-0.326 -0.326)"
                        fill="none"
                      />
                      <path
                        id="Path_656"
                        data-name="Path 656"
                        d="M21.684,24.241l-1.895-1.895a1.5,1.5,0,0,1,0-2.121l1.895-1.895a1.5,1.5,0,0,1,2.121,0L25.7,20.225a1.5,1.5,0,0,1,0,2.121l-1.895,1.895A1.5,1.5,0,0,1,21.684,24.241Z"
                        transform="translate(-6.614 -5.556)"
                        fill="#fff"
                      />
                      <path
                        id="Path_657"
                        data-name="Path 657"
                        d="M17.295,2.56H3.905A2.809,2.809,0,0,0,1.1,5.365v8.582a2.809,2.809,0,0,0,2.805,2.805h6.631a.574.574,0,0,0,0-1.148H3.905a1.66,1.66,0,0,1-1.658-1.658V9.5h16.7v2.455a.574.574,0,1,0,1.148,0V5.365A2.809,2.809,0,0,0,17.295,2.56ZM3.905,3.708H17.295a1.66,1.66,0,0,1,1.658,1.658v.38H2.248v-.38A1.659,1.659,0,0,1,3.905,3.708ZM2.248,8.349V6.893h16.7V8.349H2.248Z"
                        transform="translate(0)"
                        fill="#7e7e7e"
                      />
                      <path
                        id="Path_658"
                        data-name="Path 658"
                        d="M5.982,16.475H7.74a.574.574,0,1,0,0-1.148H5.982a.574.574,0,1,0,0,1.148Z"
                        transform="translate(-1.561 -4.627)"
                        fill="#7e7e7e"
                      />
                      <path
                        id="Path_659"
                        data-name="Path 659"
                        d="M5.982,19.863H9.5a.574.574,0,0,0,0-1.148H5.982a.574.574,0,1,0,0,1.148Z"
                        transform="translate(-1.561 -5.855)"
                        fill="#7e7e7e"
                      />
                      <path
                        id="Path_660"
                        data-name="Path 660"
                        d="M23.886,17.609a2.123,2.123,0,0,0-2.933,0L19.058,19.5a2.075,2.075,0,0,0,0,2.933l1.895,1.9h0a2.076,2.076,0,0,0,2.933,0l1.9-1.9a2.078,2.078,0,0,0,0-2.933Zm1.084,4.016-1.9,1.9a.929.929,0,0,1-1.31,0l-1.895-1.895a.928.928,0,0,1,0-1.31l1.895-1.895a.949.949,0,0,1,1.31,0l1.895,1.895A.927.927,0,0,1,24.97,21.625Z"
                        transform="translate(-6.288 -5.241)"
                        fill="#7e7e7e"
                      />
                      <path
                        id="Path_661"
                        data-name="Path 661"
                        d="M24.349,19.97a.574.574,0,0,0-.574.574V21.9a.574.574,0,1,0,1.148,0V20.544A.574.574,0,0,0,24.349,19.97Z"
                        transform="translate(-8.218 -6.31)"
                        fill="#7e7e7e"
                      />
                      <path
                        id="Path_662"
                        data-name="Path 662"
                        d="M24.349,24.48a.574.574,0,0,0-.574.574v.115a.574.574,0,1,0,1.148,0v-.115A.574.574,0,0,0,24.349,24.48Z"
                        transform="translate(-8.218 -7.944)"
                        fill="#7e7e7e"
                      />
                    </g>
                  </svg>
                </div>
                <div className="settings-menu-text">
                  <h2>Update Payment Info</h2>
                </div>
                <div className="settings-right-arrow">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14.95"
                    height="12.147"
                    viewBox="0 0 14.95 12.147"
                  >
                    <g
                      id="Group_44"
                      data-name="Group 44"
                      transform="translate(0.75 1.057)"
                    >
                      <line
                        id="Line_55"
                        data-name="Line 55"
                        x2="13.157"
                        transform="translate(0 5.016)"
                        fill="none"
                        stroke="#0182f0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      />
                      <path
                        id="Path_267"
                        data-name="Path 267"
                        d="M13,8l4.269,5.016L13,18.033"
                        transform="translate(-3.819 -8)"
                        fill="none"
                        stroke="#0182f0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      />
                    </g>
                  </svg>
                </div>
              </Link>}
              {settings?.HasCarDetails==1 ?
              <Link
                to={"/" + params.carwashname + "/" + pageURLs.car_info}
                className="settings-menu-item align-items-center"
              >
                <div className="settings-menu-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18.819"
                    height="13.329"
                    viewBox="0 0 18.819 13.329"
                  >
                    <g
                      id="Artboard_1_1_"
                      data-name="Artboard 1 (1)"
                      transform="translate(-0.24 -4.29)"
                    >
                      <path
                        id="Path_676"
                        data-name="Path 676"
                        d="M13.751,14.874a.488.488,0,0,1,.488.488v.264a1.388,1.388,0,0,0,1.393,1.393h1.393a1.388,1.388,0,0,0,1.393-1.393V12.281a4.147,4.147,0,0,0-.732-2.359L16.537,8.235l-1.3-1.921A3.255,3.255,0,0,0,12.542,4.89H6.736A3.255,3.255,0,0,0,4.042,6.313l-1.3,1.921L1.592,9.923A4.147,4.147,0,0,0,.86,12.281v3.345a1.388,1.388,0,0,0,1.393,1.393H3.646a1.388,1.388,0,0,0,1.393-1.393v-.264a.488.488,0,0,1,.488-.488h8.2Z"
                        transform="translate(0)"
                        fill="none"
                        stroke="#7e7e7e"
                        stroke-miterlimit="10"
                        stroke-width="1.2"
                      />
                      <path
                        id="Path_677"
                        data-name="Path 677"
                        d="M18.459,8.14H16.283A3.346,3.346,0,0,1,13.457,9.5H5.832A3.346,3.346,0,0,1,3.006,8.14H.84"
                        transform="translate(0 0.054)"
                        fill="none"
                        stroke="#7e7e7e"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        stroke-width="1.2"
                      />
                      <circle
                        id="Ellipse_42"
                        data-name="Ellipse 42"
                        cx="0.752"
                        cy="0.752"
                        r="0.752"
                        transform="translate(2.792 11.295)"
                        fill="#7e7e7e"
                      />
                      <circle
                        id="Ellipse_43"
                        data-name="Ellipse 43"
                        cx="0.752"
                        cy="0.752"
                        r="0.752"
                        transform="translate(14.951 11.275)"
                        fill="#7e7e7e"
                      />
                    </g>
                  </svg>
                </div>
                <div className="settings-menu-text">
                  <h2>Car Info</h2>
                </div>
                <div className="settings-right-arrow">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14.95"
                    height="12.147"
                    viewBox="0 0 14.95 12.147"
                  >
                    <g
                      id="Group_44"
                      data-name="Group 44"
                      transform="translate(0.75 1.057)"
                    >
                      <line
                        id="Line_55"
                        data-name="Line 55"
                        x2="13.157"
                        transform="translate(0 5.016)"
                        fill="none"
                        stroke="#0182f0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      />
                      <path
                        id="Path_267"
                        data-name="Path 267"
                        d="M13,8l4.269,5.016L13,18.033"
                        transform="translate(-3.819 -8)"
                        fill="none"
                        stroke="#0182f0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      />
                    </g>
                  </svg>
                </div>
              </Link> :""}

              <Link
                to={"/" + params.carwashname + "/" + pageURLs.contactus}
                className="settings-menu-item align-items-center"
              >
                <div className="settings-menu-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19"
                    height="14.078"
                    viewBox="0 0 19 14.078"
                  >
                    <g transform="translate(-11.45 -16.98)">
                      <path
                        d="M2.265-.55h13.37A2.818,2.818,0,0,1,18.45,2.265v8.448a2.818,2.818,0,0,1-2.815,2.815H2.265A2.818,2.818,0,0,1-.55,10.713V2.265A2.818,2.818,0,0,1,2.265-.55Zm13.37,12.864a1.6,1.6,0,0,0,1.6-1.6V2.265a1.6,1.6,0,0,0-1.6-1.6H2.265a1.6,1.6,0,0,0-1.6,1.6v8.448a1.6,1.6,0,0,0,1.6,1.6Z"
                        transform="translate(12 17.53)"
                        fill="#7e7e7e"
                      />
                      <path
                        d="M21.091,26.756A.57.57,0,0,1,20.7,26.6l-8.027-7.38a.756.756,0,0,1-.089-.975.567.567,0,0,1,.863-.1l7.64,7.024,7.64-7.024a.567.567,0,0,1,.863.1.756.756,0,0,1-.089.975L21.478,26.6A.57.57,0,0,1,21.091,26.756Z"
                        transform="translate(-0.141 -0.417)"
                        fill="#7e7e7e"
                      />
                    </g>
                  </svg>
                </div>
                <div className="settings-menu-text">
                  <h2>Contact Us</h2>
                </div>
                <div className="settings-right-arrow">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14.95"
                    height="12.147"
                    viewBox="0 0 14.95 12.147"
                  >
                    <g
                      id="Group_44"
                      data-name="Group 44"
                      transform="translate(0.75 1.057)"
                    >
                      <line
                        id="Line_55"
                        data-name="Line 55"
                        x2="13.157"
                        transform="translate(0 5.016)"
                        fill="none"
                        stroke="#0182f0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      />
                      <path
                        id="Path_267"
                        data-name="Path 267"
                        d="M13,8l4.269,5.016L13,18.033"
                        transform="translate(-3.819 -8)"
                        fill="none"
                        stroke="#0182f0"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                      />
                    </g>
                  </svg>
                </div>
              </Link>

              <a
                onClick={() => signout()}
                href={void 0}
                className="settings-menu-item align-items-center"
              >
                <div className="settings-menu-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19"
                    height="14.581"
                    viewBox="0 0 19 14.581"
                  >
                    <g transform="translate(20.25 18.331) rotate(180)">
                      <path
                        d="M13.18,11.913a.663.663,0,0,0-.663-.663H1.913a.663.663,0,0,0,0,1.326h10.6A.663.663,0,0,0,13.18,11.913Z"
                        transform="translate(0 -0.872)"
                        fill="#7e7e7e"
                        fillRule="evenodd"
                      />
                      <path
                        d="M5.474,7.944a.663.663,0,0,0-.937,0L1.444,11.037a.663.663,0,0,0,0,.937l3.093,3.093a.663.663,0,1,0,.937-.937L2.85,11.506,5.474,8.881A.663.663,0,0,0,5.474,7.944Z"
                        transform="translate(0 -0.465)"
                        fill="#7e7e7e"
                        fillRule="evenodd"
                      />
                      <path
                        d="M13.741,5.076A5.872,5.872,0,0,0,8.5,8.324a.663.663,0,0,1-1.183-.6,7.193,7.193,0,0,1,13.626,3.315,7.376,7.376,0,0,1-.259,1.942.663.663,0,1,1-1.279-.349,6.053,6.053,0,0,0,.212-1.593A5.923,5.923,0,0,0,13.741,5.076ZM7.614,13.465a.663.663,0,0,1,.89.293,5.872,5.872,0,0,0,5.237,3.248,5.8,5.8,0,0,0,3.494-1.167.663.663,0,1,1,.8,1.06,7.122,7.122,0,0,1-4.29,1.432,7.2,7.2,0,0,1-6.42-3.976A.663.663,0,0,1,7.614,13.465Z"
                        transform="translate(-0.698)"
                        fill="#7e7e7e"
                        fillRule="evenodd"
                      />
                    </g>
                  </svg>
                </div>
                <div className="settings-menu-text">
                  <h2>Sign Out</h2>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* signout confirmation Modal */}
      <Modal
        show={showLogoutConfirmation}
        onHide={handleOnHide}
        centered
        className="notification-modal"
      >
        <Modal.Body className="text-center">
          <h6>Are you sure you want to sign out?</h6>
        </Modal.Body>
        <Modal.Footer className="d-grid">
          <Button variant="light" className="m-0" onClick={handleOnHide}>
            No
          </Button>
          <Button
            variant="primary"
            className="primary-btn btn-main m-0"
            onClick={ConfirmLogout}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      <CWFooter activeLink="Settings" />
    </div>
  );
};

export default Settings;
